import type { NormalizeOAS, OASOutput, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/export-project/check-progress/{packageId}', 'get'>;
type ResponseBody = OASOutput<O, '/api/export-project/check-progress/{packageId}', 'get'>;

type Params = {
  packageId: string;
  sasToken: string;
  fileName: string;
};

type Result = {
  isValid: boolean;
  urlToDownloadPackageFrom: string | null;
};

export const checkExportProgressFactory = (apiClient: ApiClient) => {
  const checkExportProgress = async (variables: Params) => {
    const requestBody = mapInputToRequestBody(variables);
    const response = await apiClient['/api/export-project/check-progress/{packageId}'].get(requestBody);
    const responseBody = await response.json();

    return mapResponseToResult(responseBody);
  };

  const mapInputToRequestBody = (input: Params): RequestParams => {
    return {
      params: {
        packageId: input.packageId,
      },
      query: {
        sasToken: input.sasToken,
        fileName: input.fileName,
      },
    };
  };

  const mapResponseToResult = (response: ResponseBody): Result => {
    return {
      isValid: response.isValid,
      urlToDownloadPackageFrom: response.urlToDownloadPackageFrom ?? null,
    };
  };

  return checkExportProgress;
};
